<script>
import Header from '../header.vue';
import OrderView from './components/order.vue';
import Grid from './components/order-items-list.vue';
import Messages from '@/components/widgets/order-messages/list';

/**
 * Dashboard Component
 */
export default {
  page: {
    title: 'Order',
  },
  data() {
    return {
      collapseMessage: false,
      orderReceptionDate: null,
      items: [
        {
          text: '',
          href: '/orders/manage',
        },
        {
          text: '',
          active: true,
        },
      ],
    };
  },
  components: {
    Header,
    OrderView,
    Grid,
    Messages,
  },
};
</script>

<template>
  <div>
    <Header />
    <b-card class="page">
      <OrderView :orderIdPublic="$route.params.idPublic" />
      <div style="display: flex">
        <div style="flex-grow: 1">
          <Grid
            :orderIdPublic="$route.params.idPublic"
            :orderReceptionDate="orderReceptionDate"
          />
        </div>
        <i
          @click="collapseMessage = !collapseMessage"
          :class="
            !collapseMessage
              ? 'ml-3 mdi mdi-36px mdi-chevron-right'
              : 'ml-3 mdi mdi-36px mdi-chevron-left'
          "
        >
        </i>
        <Transition name="slide-left">
          <Messages
            v-show="!collapseMessage"
            style="width: 350px; overflow-x: hidden"
            :userIdPublic="null"
            :orderIdPublic="$route.params.idPublic"
          />
        </Transition>
      </div>
    </b-card>
  </div>
</template>

<style scoped>
.page {
  padding: 30px 30px 0 30px;
  max-width: 1500px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  min-height: calc(100vh - 102px);
}

.slide-left-enter-active {
  animation: slide-left-in 0.5s;
}
.slide-left-leave-active {
  animation: slide-left-in 0.5s reverse;
}
@keyframes slide-left-in {
  0% {
    width: 0;
  }
  100% {
    width: 350px;
  }
}
</style>